import { Outlet } from "react-router-dom";
import { Dispatch } from "@reduxjs/toolkit";
import { connect } from "react-redux";

const ResponsiveLayout = () => {
  return (
    <>
      <Outlet />
    </>
  );
};

function mapStateToProps(state: any) {
  return {};
}

function mapDispatchToProps(dispatch: Dispatch) {
  return {};
}

// export default ResponsiveLayout;
export default connect(mapStateToProps, mapDispatchToProps)(ResponsiveLayout);
